import "@/user/common";
import "@/shared/inquiry";
import "@/shared/privacy_check";
import { loadContents } from "@/shared/kodawari_link";
import Swiper from "swiper";
import { EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";

document.addEventListener("DOMContentLoaded", () => {
  // トップページのキービジュアル、アイテムのアイキャッチ画像の切替
  document.querySelectorAll(".zoom_slider").forEach((element) => {
    const swiperSlides = element.querySelectorAll(
      ".swiper-wrapper .swiper-slide",
    );

    // eslint-disable-next-line no-new
    new Swiper(element, {
      modules: [EffectFade, Autoplay],
      loop: swiperSlides.length > 1,
      speed: 1500,
      effect: "fade",
      autoplay: {
        delay: 5000,
      },
      allowTouchMove: false,
    });
  });

  // こだわりリンク取得
  // e.g https://wptest2-metal.local.smtk.jp/api/fair/summary
  loadContents();
});
